module.exports = __webpack_public_path__ + "img/list.f491a05f.svg";